<template>
  <div class="block23">
    <!-- 返回 -->
    <div class="return">
      <router-link to="/">
        <span class="arrow"></span>返回首页
      </router-link>
    </div>
    <!-- 返回 -->
    <!-- 内容 -->
    <div class="container">
      <h2 class="title1">制动器</h2>
      <div class="container-content">
        <p class="text_line">检查前制动液</p>
        <ul class="numberspace">
          <li>
            <em>1</em>将摩托车直立放置于稳固平坦的平面上。
          </li>
          <li>
            <em>2</em>前:检查制动液储液箱是否处于水平状态，液位是否在下部液位标记之上。
          </li>
          <li>
            <em>3</em>后:检查制动液储液箱是否处于水平状态，液位是否在上部标位和下部液位标记之间。
          </li>
        </ul>
        <p>
          如果任何一个储液箱中的制动液液位低于下限液位标记，或制动手柄和踏板的自由行程超标，必须检查制动片是否磨损。如果制动片没有磨损，则可能存在泄漏。请交由本田特约维修店检修摩托车。
        </p>
        <img src="./img/img1.jpg" width="100%" alt="图片" />
        <p class="text_line" id="qzdsb">检查前制动片</p>
        <p>
          检查制动片磨损指示标记的状况。<br>如果制动片已磨损至指示标记处，则需要更换制动片。
        </p>
        <img  width="100%" src="./img/img2.png" alt="图片" />
      
        <ul class="numberspace">
          <li>
            <em>1</em>前制动片: 从制动钳下面检查制动片。<br>制动片衬片的厚度：<br>2.7 mm（磨损至指示标记处）
          </li>
          <li>
            <em>2</em>后制动片: 检查摩托车尾部的刹车片。<br>制动片衬片的厚度：<br>4.5 mm（磨损至指示标记处）
          </li>
        </ul>
        <p>
          必要时，请让经销商更换制动片。<br>请务必同时更换左右制动片。
        </p>
        <p id="scdkg" class="text_line">调节刹车灯开关</p>
        <p>
          检查刹车灯开关的操作。
        </p>
        <p>
          拆下<router-link to="/block20/cehuzhao">右侧盖板</router-link>。<br>按住刹车灯开关，如果是开关操作太慢转动调节螺母的方向A，如果是开关操作太快转动调节螺母的方向B。<br>调整完成后，安装右侧盖板。
        </p>
        <img src="./img/img3.jpg" width="100%" alt="图片" />
      </div>
      <div class="foot-btn">
        <div class="prev">
          <router-link to="/block22">上一页</router-link>
        </div>
        <div class="next">
          <router-link to="/block24">下一页</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["id"],
  watch: {'$route'(to, from) {if(this.id != null) {setlink(this.id);}}},
  mounted() {
    setlink(this);

  },
  methods: {
    goto(path) {this.$router.push({ path: path });}
  }
};
</script>